import CustomInputIcon from './CustomInputIcon';

const PluginIcon = () => <CustomInputIcon />;

export { PluginIcon };
